const de = {
  code: 'de',
  short: 'DE',
  label: 'Deutsch',
  native: 'Deutsch',
  hero: {
    badge: 'Reinigungsservice • Bratislava',
    title: 'Sauberer Raum. Freier Kopf.',
    lead: 'Zuverlässige Wohn- und Büroreinigung mit transparenten Preisen und einfacher Buchung.',
    cta: 'Jetzt buchen',
    whatsapp: 'WhatsApp'
  },
  header: {
    home: 'Startseite',
    services: 'Leistungen',
    contact: 'Kontakt',
    book: 'Buchen',
    whatsapp: 'WhatsApp',
    language: 'Sprache'
  },
  home: {
    licensed: 'Lizenziert • Versichert • Mittel inklusive',
    firstCleanDiscountBadge: '10 %',
    firstCleanDiscount: 'Rabatt auf die erste Reinigung',
    servicesTitle: 'Unsere Leistungen',
    seeDetails: 'Details ansehen →',
    whyTitle: 'Warum Sparklean?',
    reasons: [
      'Zuverlässiges, geprüftes Spezialistenteam',
      'Fachkräfte mit Referenzen und nachweisbarer Erfahrung',
      'Flexible Termine inkl. Abende',
      'Feste Preise, keine versteckten Gebühren'
    ],
    areaTitle: 'Einsatzgebiet',
    areaCopy: 'Bratislava und Umgebung.',
    quote: 'Angebot anfordern'
  },
  optional: 'optional',
  servicesPage: {
    title: 'Leistungen',
    subtitle: 'Klicken Sie auf eine Karte, um Checklisten, Galerie und Preisnotizen zu sehen.'
  },
  notFound: {
    message: 'Seite nicht gefunden.',
    back: 'Zur Startseite'
  },
  serviceDetail: {
    notFound: 'Leistung nicht gefunden',
    back: 'Zurück zu Leistungen',
    bookThis: 'Leistung buchen',
    allServices: 'Alle Leistungen'
  },
  contact: {
    title: 'Kontakt',
    hours: 'Antworten Mo–Sa 8:00–20:00.',
    emailLabel: 'E-Mail',
    phoneLabel: 'Telefon',
    whatsappAvailable: 'Auch per WhatsApp erreichbar',
    whatsapp: 'Nachricht auf WhatsApp',
    email: 'E-Mail senden',
    office: 'Büro',
    address: 'Karpatské námestie 10A, Bratislava, Slowakei'
  },
  booking: {
    title: 'Buchung',
    subtitle: 'Erzählen Sie uns von Ihrem Objekt und Wunschdatum. Wir bestätigen per E-Mail oder WhatsApp.',
    fullName: 'Vollständiger Name',
    fullNamePlaceholder: 'Max Mustermann',
    serviceField: 'Leistung',
    dateField: 'Bevorzugtes Datum',
    datePlaceholder: 'TT-MM-JJJJ',
    timeField: 'Bevorzugte Zeit',
    nameField: 'Name',
    emailField: 'E-Mail',
    phoneField: 'Telefon',
    phonePlaceholder: '+421 900 000 000',
    addressField: 'Adresse',
    addressPlaceholder: 'Straße, Hausnummer, Stadtteil',
    notesField: 'Notizen',
    notesPlaceholder: 'Haustiere, Parkhinweis, Code usw.',
    submit: 'Anfrage senden',
    chooseService: 'Leistung auswählen',
    pick: 'Wählen',
    successTitle: 'Anfrage gesendet ✅',
    successLine: 'Danke! Ihre Referenz:',
    successNote: 'Wir bestätigen bald per E-Mail oder WhatsApp.',
    calendarMonth: 'long',
    pickerDescription: 'Wählen Sie die gewünschte Reinigungsart.',
    pickerTip: 'Tipp: Sie können dies später ändern.',
    whatsappAlt: 'oder per WhatsApp schreiben',
    privacy: 'Wir schützen Ihre Daten. Mit dem Absenden stimmen Sie einer Kontaktaufnahme zu.',
    error: 'Etwas ist schiefgelaufen. Bitte erneut versuchen.',
    errorTitle: 'Anfrage nicht gesendet',
    errorMessage: 'Die Anfrage konnte nicht gesendet werden. Bitte versuchen Sie es erneut oder kontaktieren Sie uns direkt.',
    errorWhatsapp: 'WhatsApp-Chat öffnen',
    errorEmail: 'E-Mail schreiben',
    required: 'Dieses Feld ist erforderlich',
    emailError: 'Gültige E-Mail eingeben',
    phoneError: 'Zahlen, +, Leerzeichen oder Bindestrich verwenden',
    minChars: 'Mindestens 10 Zeichen',
    addressHint: 'Straße und Hausnummer eingeben',
    pickerTitle: 'Leistung wählen',
    calendarTitle: 'Datum wählen'
  },
  footer: {
    tagline: 'Professionelle Reinigungsdienste in Bratislava und Umgebung.',
    rights: 'Alle Rechte vorbehalten.',
    getInTouch: 'Kontakt aufnehmen',
    chat: 'Auf WhatsApp chatten'
  },
  services: [
    {
      slug: 'regular-cleaning',
      title: 'Regelmäßige Reinigung',
      short: 'Halten Sie Ihr Zuhause täglich oder wöchentlich sauber und frisch.',
      intro: 'Regelmäßige Reinigung sorgt für Ordnung und Sauberkeit.',
      description: [
        'Wir saugen und wischen alle zugänglichen Flächen gründlich, entstauben sorgfältig und reinigen Küchen- und Badarmaturen – so bleibt Ihr Zuhause frisch, makellos und gemütlich.',
        'Empfohlene Häufigkeit: wöchentlich, zweiwöchentlich oder monatlich.'
      ],
      bullets: [
        'Böden gesaugt und gewischt',
        'Staub auf erreichbaren Flächen entfernt',
        'Bad- und Küchenelemente desinfiziert',
        'Mülleimer geleert und Beutel gewechselt'
      ],
      priceNote: '18 € / Stunde • Minimum 2 Stunden'
    },
    {
      slug: 'general-cleaning',
      title: 'Grundreinigung',
      short: 'Balance zwischen regelmäßiger und Tiefenreinigung.',
      intro: 'Eine detailliertere Reinigung, die über die Routine hinausgeht.',
      description: [
        'Enthält alle Schritte der regelmäßigen Reinigung plus gründliche Küchen- und Badpflege, Reinigung der Außenseiten von Geräten, Innenraum von Ofen und Kühlschrank sowie Pflege der Tierbereiche.',
        'Empfohlene Häufigkeit: wöchentlich, alle zwei Wochen oder einmal im Monat.'
      ],
      bullets: [
        'Checkliste der regelmäßigen Reinigung inklusive',
        'Detailreinigung von Küche und Bad',
        'Innenreinigung von Ofen und Kühlschrank',
        'Entfernung von Tierhaaren und Reinigung der Tierbereiche (Futterplatz, Katzenklo)'
      ],
      priceNote: '20 € / Stunde • Minimum 2 Stunden'
    },
    {
      slug: 'deep-cleaning',
      title: 'Tiefenreinigung',
      short: 'Komplettes Top-to-Bottom-Cleaning für maximale Frische.',
      intro: 'Die gründlichste Reinigung mit Fokus auf schwer erreichbare Bereiche und Geräte.',
      description: [
        'Umfasst jeden Schritt der Grundreinigung sowie Innen- und Außenfenster (erreichbar), Innenreinigung von Schränken und tiefgehende Pflege von Geräten wie Kühlschrank, Ofen und Mikrowelle.',
        'Auf Wunsch auch Balkonreinigung. Empfohlen, wenn alles perfekt aufgefrischt werden soll.'
      ],
      bullets: [
        'Gründliche Entfernung von Kalk und Fett',
        'Schränke und Garderoben innen gereinigt',
        'Fenster innen und außen (erreichbar)',
        'Geräte komplett tiefengereinigt'
      ],
      priceNote: '22 € / Stunde • Minimum 2 Stunden'
    },
    {
      slug: 'post-construction-cleaning',
      title: 'Bauendreinigung',
      short: 'Staub, Farbe und Schutt nach Renovierung entfernen.',
      intro: 'Professionelle Reinigung nach Bau- oder Renovierungsarbeiten.',
      description: [
        'Wir entfernen Staub, Kleber, Farbe und Schutt, reinigen Fenster, Böden, Oberflächen und Bäder, damit das Objekt bezugsfertig ist – frisch, makellos und staubfrei.'
      ],
      bullets: [
        'Baustaub und Rückstände entfernen',
        'Details wie Armaturen, Steckdosen und Schalter reinigen',
        'Fenster, Rahmen und Simse säubern',
        'Finales Polieren von Böden und Flächen'
      ],
      priceNote: 'Individuelles Angebot nach Besichtigung'
    },
    {
      slug: 'move-in-move-out',
      title: 'Ein- & Auszugsreinigung',
      short: 'Ideal für Neubeginn oder reibungslosen Auszug.',
      intro: 'Detaillierte Reinigung für eine einwandfreie Übergabe.',
      description: [
        'Fokus auf Schränke, Geräte, Sockelleisten und Armaturen, damit die Immobilie makellos für Vermieter oder neue Besitzer ist.',
        'Perfekt vor Inseraten, Abnahmen oder beim Einzug.'
      ],
      bullets: [
        'Schränke und Schubladen innen gereinigt',
        'Geräteinnenräume entfettet',
        'Fenster und Rahmen abgewischt',
        'Liebe zum Detail bei Leisten und Schaltern'
      ],
      priceNote: 'Festes Angebot nach kurzer Besichtigung'
    },
    {
      slug: 'office-cleaning',
      title: 'Büroreinigung',
      short: 'Halten Sie Ihren Arbeitsplatz makellos und produktiv.',
      intro: 'Makelloses und organisiertes Büro dank Profis.',
      description: [
        'Wir reinigen alle Bereiche gründlich – von Arbeitsplätzen und Besprechungsräumen bis zu Küchen und Sanitärräumen – für eine saubere und hygienische Umgebung.',
        'Unser geschultes Team arbeitet präzise und diskret und unterstützt ein professionelles Image sowie eine angenehme Atmosphäre für Mitarbeiter und Kunden.'
      ],
      bullets: [
        'Arbeitsplätze, Meetingräume, Empfang',
        'Sanitisierung von WCs und Küchen',
        'Mülleimer geleert, Recycling betreut',
        'Flexible Zeiten außerhalb der Arbeitsstunden'
      ],
      priceNote: 'Preis auf Anfrage'
    },
    {
      slug: 'commercial-cleaning',
      title: 'Gewerbliche Reinigung',
      short: 'Professioneller Service für Restaurants, Hotels und Shops.',
      intro: 'Ein einladendes, makelloses Umfeld für Gäste und Team.',
      description: [
        'Hochwertige Reinigung für Restaurants, Hotels, Geschäfte, Salons, Fitnessstudios und Büros – jeder Bereich wirkt gepflegt und hygienisch.',
        'Wir achten auf Details: glänzende Böden und Möbel, desinfizierte Küchen und Sanitärbereiche. Wir nutzen umweltschonende Mittel und bewährte Methoden für Sicherheit und Komfort.',
        'Flexible Pläne und Reinigungszeiten passend zu Ihren Öffnungszeiten für minimale Unterbrechung.'
      ],
      bullets: [
        'Gastraum, Backoffice und Lagerflächen',
        'Desinfektion häufig berührter Stellen',
        'Bodenpflege für harte Böden und Teppiche',
        'Individuelle Pläne je nach Geschäftsart'
      ],
      priceNote: 'Preis auf Anfrage'
    },
    {
      slug: 'window-cleaning',
      title: 'Fensterreinigung',
      short: 'Kristallklare Fenster innen und außen.',
      intro: 'Klare Fenster lassen jeden Raum heller wirken.',
      description: [
        'Wir reinigen professionell Fenster in Wohnungen, Büros und Gewerbeflächen – innen und außen (nur erreichbare Bereiche).',
        'Wir nutzen streifenfreie, umweltfreundliche Mittel; Glas bleibt makellos und Rahmen glänzen. Regelmäßige Reinigung verbessert Licht, Frische und Professionalität.'
      ],
      bullets: [
        'Innen- und erreichbare Außenflächen',
        'Rahmen, Simse und Schienen abgewischt',
        'Streifenfreie, umweltfreundliche Produkte',
        'Ideal für Wohnungen, Büros und Schaufenster'
      ],
      priceNote: '25 € / Stunde • Minimum 2 Stunden'
    },
    {
      slug: 'carpet-upholstery-cleaning',
      title: 'Teppich- & Polsterreinigung',
      short: 'Tiefenreinigung und Auffrischung von Teppichen und Polstern.',
      intro: 'Wir stellen Weichheit wieder her und entfernen Gerüche.',
      description: [
        'Flecken, Allergene und Ablagerungen behandeln wir mit professioneller Technik passend zum Stoff, damit Textilien erneuert und frisch wirken.',
        'Ideal als Ergänzung zur Tiefenreinigung oder als eigenständige Auffrischung stark genutzter Bereiche.'
      ],
      bullets: [
        'Heißwasserextraktion oder Niedrigfeuchte-Verfahren',
        'Gezielte Flecken- und Geruchsbeseitigung',
        'Schonende Lösungen für empfindliche Stoffe',
        'Schnelle Trocknung für geringe Ausfallzeiten'
      ],
      priceNote: 'Preis je nach Stoffart und Fläche'
    }
  ]
};

export default de;
